import { Axios, MutationConfig } from '@helpers';
import { useMutation, useQueryClient } from 'react-query';
import { getSocialMediaLinksQueryOptions } from './get-social-links';

export const uploadCSVSocialMedia = ({ data, modelId }: { data: File; modelId: string }) => {
  const formData = new FormData();
  formData.append('file', data);
  return Axios.post(`/admin/models/${modelId}/social-media-links/csv`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

type UseUploadCSVSocialMedia = {
  mutationConfig?: MutationConfig<typeof uploadCSVSocialMedia>;
};

export const useUploadCSVSocialMedia = ({ mutationConfig }: UseUploadCSVSocialMedia = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getSocialMediaLinksQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: uploadCSVSocialMedia,
  });
};
